import Icon from "components/Icon";
import NewTable, { TableBodyData, TableHeaderColumn } from "components/NewTable";
import PageDefault from "components/PageDefault";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import usersService from "services/users.service";
import { getColorByMail } from "utils";

export default function Users(){
  const history = useHistory();
  const { t } = useTranslation()

  return (
    <PageDefault title={t('title:users')}>
      <PageDefault.Title>{t('title:users')}</PageDefault.Title>
      <PageDefault.Content>
        <Row className="mt-3 mb-3">
          <Col>
            <Link to="/admin/user/create">
              <Button>{t('button:add_user')}</Button>
            </Link>
          </Col>
        </Row>
        <NewTable>
          <TableHeaderColumn dataField="email|firstname" isAction bodyNowrap mask={(a:any[])=>{
            const [email,firstname] = a;
            return (
              <div id="header-user-area-image" style={{background:getColorByMail(email).hex,position:"relative",top:0,left:0}}>
                <div id="header-user-area-image-notimage">{firstname.substring(0,1).toUpperCase()}</div>
              </div>
            );
          }}></TableHeaderColumn>
          {/* <TableHeaderColumn dataField="id" bodyNowrap>ID</TableHeaderColumn> */}
          <TableHeaderColumn dataField="firstname|lastname" 
            bodyNowrap 
            mask={(value:any[])=>{return value.join(" ");}}
          >Nome</TableHeaderColumn>
          <TableHeaderColumn dataField="email" bodyNowrap>E-mail</TableHeaderColumn>
          <TableHeaderColumn dataField="profile.name" bodyNowrap>Profile</TableHeaderColumn>
          <TableHeaderColumn dataField="profile.type.name" bodyNowrap>Profile type</TableHeaderColumn>
          <TableHeaderColumn dataField="id|" isAction mask={(v:any[])=>{
            const [id] = v;
            return (
              <>
                <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`user/edit/${id}`);}}><Icon name="edit"/></Button>
                <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`user/show/${id}`);}}><Icon name="eye"/></Button>
              </>
            );
          }}>Ação</TableHeaderColumn>
          <TableBodyData 
            request={usersService}
            filterDefaut={{
              fields:"id,firstname,lastname,email,profile_id",
              embed:"profile:id,name,profile_type_id|profile.type:id,name"
            }}
          />
        </NewTable>
      </PageDefault.Content>
    </PageDefault>
  );
}